function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "user",
  transform: "translate(3.621 4.404)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_469",
  "data-name": "\\uD328\\uC2A4 469",
  d: "M13.113,17.931v-.977A2.135,2.135,0,0,0,10.835,15H6.278A2.135,2.135,0,0,0,4,16.954v.977",
  transform: "translate(-4 -8.003)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\uD0C0\\uC6D0_16",
  "data-name": "\\uD0C0\\uC6D0 16",
  cx: 2.516,
  cy: 2.516,
  r: 2.516,
  transform: "translate(2.04 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD0C0\\uC6D0_17",
  "data-name": "\\uD0C0\\uC6D0 17",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.178,
  cy: 8.178,
  r: 8.178,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.178,
  cy: 8.178,
  r: 7.678,
  fill: "none"
}));

function SvgMyMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_1292",
    "data-name": "\\uADF8\\uB8F9 1292",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.356,
    height: 16.356,
    viewBox: "0 0 16.356 16.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMenu);
export default __webpack_public_path__ + "static/media/myMenu.a98074c6.svg";
export { ForwardRef as ReactComponent };